module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/VnPSwO/tc-custom/9781481406185.jpg?1730530305655",
      "alt": "This image is the cover for the book Coconut Clue, Candy Fairies"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Coconut Clue, Candy Fairies\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("The Candy Fairies go on a gummy-tastic adventure full of flavor when they discover a tropical lagoon—with a tropical treasure!")]), _c('br'), _c('br'), _vm._v("Raina the Gummy Fairy wants to discover new flavors for her gummy candy. On the far side of Gummy Forest there’s a lagoon where she finds tropical gummy flavors that she has only read about—pineapple, mango, and tangerine! But how are these yummy flavors made? Is there a hidden secret? The fairies start to harvest the new treats and notice signs of some ancient artifacts. Could they be the key to these tropical treats?\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Helen Perelman\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Helen Perelman has worked in a children’s bookstore and was a children’s book editor. She now writes full-time in New York, where she lives with her husband and two daughters. Visit her online at HelenPerelman.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Aladdin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0